interface AnalyticsEvent {
  event: string;
  payload?: Record<string, unknown>;
}

export function trackAnalytics(event: AnalyticsEvent): void {
  const globalWindow = window as Window & { dataLayer?: unknown[] };
  if (!globalWindow.dataLayer) {
    globalWindow.dataLayer = [];
  }
  globalWindow.dataLayer.push({ event: event.event, ...event.payload });
}
